<template>
  <div>
    <dashboard-header :text='$t("nav.nurseCallHistory")'/>
    <v-card
        elevation="0"
        class="card-border-10">

      <d-table
          class="pa-10"
          :table-data="processedItems"
          :fields="tableFields"
          :loading="loading"
          :item-click="viewDetail"
          :get-items="getItems"
          :custom-total-rows="processedItems.length"
      >
        <template v-slot:item.timeInfo="{ item }">
          <div style="white-space: pre-line;">{{ item.timeInfo }}</div>
        </template>
      </d-table>

    </v-card>
  </div>
</template>

<script>
import {API2} from "../../api";
import DashboardHeader from "../component/DashboardHeader";
import dTable from "../base/DataTable.vue";
import mixin from "../../mixin";

export default {
  components: {DashboardHeader, dTable},
  mixins: [mixin],
  data() {
    return {
      // table
      items: [],
      totalRows: null,
      optionParams: null,
    };
  },
  mounted() {
    this.onTab()
  },
  computed: {
    tableFields() {
      return [
        {value: "nurseCallId", text: "ID"},
        {value: "roomBedInfo", text: this.$t("nurseCall.roomBed")},
        {value: "callInfo", text: this.$t("nurseCall.callDetails")},
        {value: "statusText", text: this.$t("nurseCall.status")},
        {value: "employeeFullName", text: this.$t("nurseCall.creator")},
        {value: "timeInfo", text: this.$t("nurseCall.timeline")},
      ];
    },
    processedItems() {
      return this.items.map(item => ({
        data: item,
        nurseCallId: item.nurseCallId,
        // Gom thông tin phòng/giường
        roomBedInfo: `${this.$t("nurseCall.room")} ${item.roomNumber || '-'} - ${this.$t("nurseCall.bed")} ${item.bedNumber || '-'}`,
        // Gom thông tin cuộc gọi (loại + độ ưu tiên)
        callInfo: `${this.getCallTypeText(item.callType)} - ${this.getPriorityText(item.priority)}`,
        statusText: this.getStatusText(item.status),
        employeeFullName: item.employeeFullName || '-',
        // Gom thông tin thời gian
        timeInfo: this.getTimeInfo(item)
      }));
    },
  },
  methods: {
    onTab() {
      this.getItems(this.optionParams)
    },
    async getItems(optionParams) {
      if (!optionParams) optionParams = {}
      this.optionParams = optionParams
      let res = await this.get(API2.NURSE_CALL_HISTORY, optionParams)
      if (!res) return

      // Handle the nested response structure
      let dataArray = res.data?.data || res.data || res.rows || res || []
      if (!Array.isArray(dataArray)) {
        return
      }

      for (let item of dataArray) {
        // Add employee names
        item.employeeFullName = item.createdBy?.name || '';
        item.acceptedByFullName = item.acceptedBy?.name || '';

        // Format dates
        if (item.createdAt) {
          item.createdAtFormatted = this.formatDateTime(item.createdAt);
        }
        if (item.acceptedAt) {
          item.acceptedAtFormatted = this.formatDateTime(item.acceptedAt);
        }
        if (item.completedAt) {
          item.completedAtFormatted = this.formatDateTime(item.completedAt);
        }
      }

      this.items = dataArray
      this.totalRows = res.data?.total || dataArray.length
    },
    getPriorityText(priority) {
      return priority ? this.$t("nurseCall.priorityYes") : this.$t("nurseCall.priorityNo");
    },
    getCallTypeText(callType) {
      switch(callType?.toLowerCase()) {
        case 'call':
          return this.$t("nurseCall.callTypeCall");
        case 'present':
          return this.$t("nurseCall.callTypePresent");
        case 'clear':
          return this.$t("nurseCall.callTypeClear");
        default:
          return callType || '';
      }
    },
    getStatusText(status) {
      switch(status?.toLowerCase()) {
        case 'pending':
          return this.$t("nurseCall.statusPending");
        case 'accepted':
          return this.$t("nurseCall.statusAccepted");
        case 'present':
          return this.$t("nurseCall.statusPresent");
        case 'completed':
          return this.$t("nurseCall.statusCompleted");
        case 'cancelled':
          return this.$t("nurseCall.statusCancelled");
        case 'missed':
          return this.$t("nurseCall.statusMissed");
        default:
          return status || '';
      }
    },
    viewDetail(item) {
      // Store the detail data in sessionStorage for persistence
      sessionStorage.setItem(`nurseCall_${item.data.nurseCallId}`, JSON.stringify(item.data))
      this.$router.push(`/nurse-call-history/${item.data.nurseCallId}`)
    },
    formatDateTime(dateTimeString) {
      if (!dateTimeString) return '';
      const date = new Date(dateTimeString);
      return date.toLocaleString('vi-VN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('vi-VN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },
    getTimeInfo(item) {
      const timeLines = [];
      
      // Thời gian tạo
      if (item.createdAtFormatted) {
        timeLines.push(`${this.$t("nurseCall.created")}: ${item.createdAtFormatted}`);
      }
      
      // Thời gian tiếp nhận (nếu có)
      if (item.acceptedAtFormatted && item.acceptedByFullName) {
        timeLines.push(`${this.$t("nurseCall.accepted")}: ${item.acceptedAtFormatted} (${item.acceptedByFullName})`);
      }
      
      // Thời gian hoàn thành (nếu có)
      if (item.completedAtFormatted) {
        timeLines.push(`${this.$t("nurseCall.completed")}: ${item.completedAtFormatted}`);
      }
      
      return timeLines.join('\n') || '-';
    },
  }
};
</script>

<style scoped>
.status-chip {
  padding: 4px 8px;
  border-radius: 4px;
  color: white;
  font-size: 12px;
  font-weight: bold;
}
</style>

<style>
/* Make table rows clickable */
.v-data-table tbody tr {
  cursor: pointer;
}

.v-data-table tbody tr:hover {
  background-color: #f5f5f5 !important;
}
</style>